import { Heading, HStack, IconButton } from '@chakra-ui/react';
import { HiChevronLeft } from 'react-icons/hi2';
import { useNavigate } from 'react-router-dom';

export const RatesNav = () => {
  const navigate = useNavigate();

  const handleBack = () => navigate(-1);

  return (
    <HStack px="6" pt="4">
      <IconButton aria-label="back button" size="sm" variant="ghost" icon={<HiChevronLeft />} onClick={handleBack} />
      <Heading fontSize="lg">Rates Importer</Heading>
    </HStack>
  );
};
